<template>
  <div class="searchAreaStyle d-flex align-center">
    <div class="titleStyle">{{ $t('sale.sale_history-search') }}</div>
    <v-text-field
      class="ml-16 mr-4"
      v-model="inputedValue.productName"
      :placeholder="$t('sale.sale_sale_keyword-search')"
      outlined
      dense
      hide-details
    >
    </v-text-field>
    <v-checkbox
      class="checkboxLabel"
      v-model="inputedValue.InvalidData"
      :label="$t(checkboxLabel)"
    ></v-checkbox>
  </div>
</template>
<script>
export default {
  data: () => ({
    //
  }),
  props: {
    value: {},
    clientNameList: {
      type: Array,
      require: true,
      default: () => []
    },
    checkboxLabel: { default: 'sale.sale_dont-show-invalid-data' }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.searchAreaStyle {
  height: 70px;
}
.selectBoxStyle {
  width: 340px;
  margin: 0px 16px 0px 63px !important;
}
.textButtonStyle {
  margin: 0px 21px;
}
::v-deep .checkboxLabel .v-label {
  font-size: 14px;
  color: #333;
  margin-top: 3px;
}
</style>
